<template>
    <div id="overlayLoader">
        <div class="contentLoader">
            <div class="content-table">
                <div class="center-content">
                    <div class="loader">Loading...</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'spinner'
}
</script>
